import {mount} from '@21torr/dune/mount.js';

import {initAccordion} from "./atom/accordion.js";
import {initFormInput} from "./form/forms.js";
import {initFormHelp} from "./form/form-help.js";
import {initMicroAnimation} from "./micro-animation.js";
import {initTextLink} from "./atom/text-link.js";
import {initFormStepDisplay} from "./form/form-step-display.js";
import "./lib/modal/modals.js";
import {initFormPasswordCheck} from "./form/form-password-check.js";

mount(".accordion-bg", initAccordion);
mount('.form-section .form-input', initFormInput);
mount('.form-help', initFormHelp);
mount('.form-step-display', initFormStepDisplay);
mount(".text-link", initTextLink);
mount('.form-password-check', initFormPasswordCheck);


initMicroAnimation();